import widgets from './widgets';
import cards from './cards';
import elements from './elements';
import modals from './modals';

const Components = {
  ...widgets,
  ...cards,
  ...elements,
  ...modals,
};

Components.install = (Vue, options = {}) => {
  registry(Vue, Components);
};

function registry(Vue, components) {
  for (const componentName in components) {
    const component = components[componentName];
    if (component && componentName !== 'install') {
      if(component.name === undefined) {
        registry(Vue, component);
      } else {
        Vue.component(component.name, component);
      }
    }
  }
}

export default Components;



// WEBPACK FOOTER //
// ./src/components/index.js